import { render, staticRenderFns } from "./data_kendaraan.vue?vue&type=template&id=e0ce8bf2&scoped=true&"
import script from "./data_kendaraan.vue?vue&type=script&lang=js&"
export * from "./data_kendaraan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ce8bf2",
  null
  
)

export default component.exports